module.exports = require("./ar-ER.js");